"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Supply = void 0;
const GetSupplyDetails_1 = require("./GetSupplyDetails");
const GetSupplyList_1 = require("./GetSupplyList");
const GetSupplyStatusList_1 = require("./GetSupplyStatusList");
const PostSupplyAdd_1 = require("./PostSupplyAdd");
const PostSupplyChangeElements_1 = require("./PostSupplyChangeElements");
const PostSupplyChangeStatus_1 = require("./PostSupplyChangeStatus");
const PostSupplyEdit_1 = require("./PostSupplyEdit");
const PostSupplyDelete_1 = require("./PostSupplyDelete");
const PostSupplySendEmail_js_1 = require("./PostSupplySendEmail.js");
__exportStar(require("./GetSupplyDetails"), exports);
__exportStar(require("./GetSupplyList"), exports);
__exportStar(require("./GetSupplyStatusList"), exports);
__exportStar(require("./PostSupplyAdd"), exports);
__exportStar(require("./PostSupplyChangeElements"), exports);
__exportStar(require("./PostSupplyChangeStatus"), exports);
__exportStar(require("./PostSupplyEdit"), exports);
__exportStar(require("./PostSupplyDelete"), exports);
__exportStar(require("./PostSupplySendEmail.js"), exports);
exports.Supply = {
    GetSupplyDetails: GetSupplyDetails_1.GetSupplyDetails,
    GetSupplyList: GetSupplyList_1.GetSupplyList,
    GetSupplyStatusList: GetSupplyStatusList_1.GetSupplyStatusList,
    PostSupplyAdd: PostSupplyAdd_1.PostSupplyAdd,
    PostSupplyChangeElements: PostSupplyChangeElements_1.PostSupplyChangeElements,
    PostSupplyChangeStatus: PostSupplyChangeStatus_1.PostSupplyChangeStatus,
    PostSupplyEdit: PostSupplyEdit_1.PostSupplyEdit,
    PostSupplyDelete: PostSupplyDelete_1.PostSupplyDelete,
    PostSupplySendEmail: PostSupplySendEmail_js_1.PostSupplySendEmail
};
//# sourceMappingURL=index.js.map